import { render, staticRenderFns } from "./SettlementDetail.vue?vue&type=template&id=3bceda39&scoped=true"
import script from "./SettlementDetail.vue?vue&type=script&lang=js"
export * from "./SettlementDetail.vue?vue&type=script&lang=js"
import style0 from "./SettlementDetail.vue?vue&type=style&index=0&id=3bceda39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bceda39",
  null
  
)

export default component.exports